import React from "react";

export default function ProductDescription({ data }) {
  return (
    <div className="description">
      <h3 className="text-center">About The Shoes</h3>
      {data ? (
        <p className="pe-2">{data.data.description}</p>
      ) : (
        <p className="loading-text">Loading</p>
      )}
    </div>
  );
}
